import CryptoJS from 'crypto-js';

export const encrypt = (text) => {
  if (!text) {
    throw new Error('No text to encrypt');
  }

  if (!process.env.REACT_APP_ENCRYPTION_KEY) {
    throw new Error('Encryption key not configured');
  }

  const key = process.env.REACT_APP_ENCRYPTION_KEY.trim();
  // console.log('Text to encrypt:', text);
  // console.log('Key length:', key.length);

  return CryptoJS.AES.encrypt(text, key).toString();
};

export const encryptCredentials = (token, serviceName, serviceKey) => {
    const credentials = {
        token,
        serviceName,
        serviceKey,
        timestamp: Date.now()
    };
    
    return encrypt(JSON.stringify(credentials));
};